import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const pendingVarsAdapter = createEntityAdapter({
    selectId: vars => vars.Id
})

const initialState = pendingVarsAdapter.getInitialState({
    status: 'idle',
    error: null
})

export const fetchPendingVarsList = createAsyncThunk('vars/fetchPendingVars', async () => {
    const response = await client.get('/VarTransactions/GetPendingVarTransactions')
    return response.data
})

const pendingVarsListSlice = createSlice({
    name: 'pendingVars',
    initialState,
    reducers: {
        Reload(state) {
            pendingVarsAdapter.removeAll(state)
            state.status = 'idle'
            state.error = null
        }
    },
    extraReducers: {
        [fetchPendingVarsList.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchPendingVarsList.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            pendingVarsAdapter.addMany(state, action.payload)
        },
        [fetchPendingVarsList.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    }
})

export default pendingVarsListSlice.reducer

export const {
    Reload
} = pendingVarsListSlice.actions

export const {
    selectAll: selectAllPendingVars,
    selectById: selectPendingVarById,
    selectIds: selectPendingVarIds,
} = pendingVarsAdapter.getSelectors((state) => state.pendingVars)